angular.module('gym.form-library', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.form-library', {
    url: '/forms?tab',
    template: require('templates/gyms/forms/form_library.html.slim'),
    reloadOnSearch: false
  }).state('gym.edit-form-library', {
    url: '/forms/:formId/edit',
    template: require('templates/gyms/forms/edit_form_library.html.slim')
  }).state('gym.new-form-library', {
    url: '/forms/new',
    template: require('templates/gyms/forms/edit_form_library.html.slim')
  });
}]);
